import {
  StyledFieldLabel,
  StyledFieldValue,
  TextboxWrapper,
} from "./UneditableTextbox.styles"
  
export interface Props {
  label: string
  numRows: number
  value?: string | number | null | undefined | readonly string[]
  type?: string
}

export default function UneditableText(props: Props) {
  return (
    <TextboxWrapper>
      <StyledFieldLabel>{props.label}</StyledFieldLabel>
      <StyledFieldValue numRows={props.numRows}>{props.value}</StyledFieldValue>
    </TextboxWrapper>
  )
}
